import { AccountDataContext, LoginTypeContext } from 'modules/context';
import { useLoginToken } from 'modules/hooks';
import { ResourceHub } from 'pages';
import React, { useContext } from 'react';
import { Route, useParams } from 'react-router-dom';
import { ProtectedRoutePropsType } from './types';

export const ProtectedRouteResourceHub: React.FunctionComponent<ProtectedRoutePropsType> =
  ({ path }) => {
    const { loginTypeContext } = useContext(LoginTypeContext);
    const { isLoggedIn } = useLoginToken();
    const { accountDataContext } = useContext(AccountDataContext);

    return (
      <Route path={path}>
        {loginTypeContext && accountDataContext && isLoggedIn() && (
          <ResourceHub />
        )}
      </Route>
    );
  };
